import Joi from 'joi'
import errorsResolver from '../schemeUtils'

export const searchClientSchema = Joi.object({
  existingClient: Joi.object({
    label: Joi.string()
      .required('')
      .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9.\\- ]{1,350}$'))
      .error(errorsResolver({
        required: `Клиент обязательное поле`,
        pattern: `Клиент содержит некорректные символы`
      })),
    value: Joi.number()
      .error(errorsResolver({
        number: `Должно быть число`
      }))
  })
    .invalid(null)
    .required()
    .error(errorsResolver({
      invalid: `Клиент обязательное поле`,
      required: `Клиент обязательное поле`
    }))
})

